export default "__VITE_ASSET__DwCuR59M__"